"use client";

import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export interface SpinnerProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
  color?: "primary" | "white" | "gray" | "info" | "warning" | "current";
  className?: string;
}

const sizeClasses = {
  xs: "size-3",
  sm: "size-4",
  md: "size-6",
  lg: "size-8",
  xl: "size-12",
  "2xl": "size-16",
} as const;

const colorClasses = {
  primary: "text-primary",
  white: "text-primary-foreground",
  gray: "text-muted",
  info: "text-info",
  warning: "text-warning",
  current: "text-current",
} as const;

export function Spinner({
  size = "md",
  color = "primary",
  className,
}: SpinnerProps) {
  return (
    <Loader2
      className={cn(
        "animate-spin inline-block",
        sizeClasses[size],
        colorClasses[color],
        className
      )}
      aria-hidden
    />
  );
}
